import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import DetailsPanel from './Panels/Details/Details'
import SeoPanel from './Panels/Seo/Seo'
import RolePanel from './Panels/Role/Role'
import HistoryPanel from './Panels/History/History'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './CreateEditUser.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const CreateEditUser = (
    {
        errUser,
        errUserClear,

        curUser,
        histPage,

        isOpen,
        userCheck,
        viewOnly,
        selectPanel,
        users,
        newDateSearch,
        newUserSearch,
        loadMore,

        locations,

        onPageDescChange,

        onDetailsUpdate,
        onSeoUpdate,
        onRoleUpdate,

        confirm,
        onConfirmNo,
        onConfirmYes,

        onAfterOpen,
        onRequestClose,
        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
        <CommError error={errUser.error} onClose={errUserClear} />

        <ConfirmModal open={confirm} heading={"Submit Changes"} msg={"Would you like to submit changes prior to leaving tab?"} onNo={onConfirmNo} onYes={onConfirmYes} />

        <div className="create-edit-user editpages productManagement">
            <h1>{viewOnly ? 'View' : 'Edit'} User Information</h1>

            <div className="form-group buttons">
                <a className="btn user-cancel btn-default" onClick={onRequestCancel} >Cancel</a>
                {
                    !viewOnly ?
                        <button className="btn user btn-primary modbrick" onClick={onRequestClose}>Submit</button>
                    :
                       null
                }
            </div>

            <ul>
                <li className="userview" panel="Details" onClick={selectPanel}>Details</li>
                <li className="userview" panel="Seo" onClick={selectPanel}>SEO Information</li>
                <li className="userview" panel="Role" onClick={selectPanel}>Role Permissions</li>
                <li className="userview" panel="Location" disabled>Location Groups</li>
                <li className="userview" panel="History" onClick={selectPanel}>Change History</li>
            </ul>

            <div className="panelFrame" id="Details"><DetailsPanel user={curUser.user} onDetailsUpdate={onDetailsUpdate} /></div>
            <div className="panelFrame" id="Seo"><SeoPanel user={curUser.user} viewOnly={viewOnly} locations={locations} onPageDescChange={onPageDescChange} onSeoUpdate={onSeoUpdate} /></div>
            <div className="panelFrame" id="Role"><RolePanel user={curUser.user} onRoleUpdate={onRoleUpdate} /></div>
            <div className="panelFrame" id="Location"></div>
            <div className="panelFrame" id="History"><HistoryPanel page={histPage} user={curUser} items={users} newDateSearch={newDateSearch} newUserSearch={newUserSearch} loadMore={loadMore} /></div>

            <div className="form-group buttons">
                <a className="btn user-cancel btn-default" onClick={onRequestCancel} >Cancel</a>
                {
                    !viewOnly ?
                        <button className="btn user btn-primary modbrick" onClick={onRequestClose}>Submit</button>
                    :
                        null
                }
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default CreateEditUser